export default "__VITE_ASSET__SWAR87gd__"